/**
 * Copyright 2025 (c) Karsten Röthig, FVA GmbH (for umati and VDW e.V.)
 */
import React, { ReactElement } from 'react';
import { SectionRowElementTable, UaPlaceholder } from 'templates/pubSub/types/TemplateType';
import { TemplateContext } from 'templates/pubSub/types/TemplateContextType';
import { usePubSubNode, usePubSubNodes } from 'utilities/PubSub/PubSubHooks';
import TemplateHelperPubSub from 'utilities/TemplateHelperPubSub';
import { NodeIdentifier } from 'utilities/PubSub/PubSubAddressSpace';
import SectionElementContentTableRow from './SectionElementContentTableRow';

interface ISectionElementContentTableRowPlaceholderProps {
  templateContext: TemplateContext;
  element: SectionRowElementTable;
  placeholder: UaPlaceholder;
  placeholderIndex: number;
  startingNodeId?: NodeIdentifier;
}

export default function SectionElementContentTableRowPlaceholder(
  props: ISectionElementContentTableRowPlaceholderProps,
): ReactElement {
  const filter = TemplateHelperPubSub.createFilter(props.templateContext.namespaces, props.placeholder.variablePath);
  const node = usePubSubNode(filter);
  const placeholderFilter = TemplateHelperPubSub.createReferenceAndTypeFilter(
    props.templateContext.namespaces,
    props.placeholder.reference,
    props.placeholder.type,
  );
  const placeholderNodes = usePubSubNodes(placeholderFilter, node);

  const nextPlaceholder =
    props.element.rowPlaceholders && props.element.rowPlaceholders.length > props.placeholderIndex + 1
      ? props.element.rowPlaceholders[props.placeholderIndex + 1]
      : undefined;

  return (
    <>
      {placeholderNodes.map((placeholderNode, placeholderNodeIndex) => (
        <>
          {nextPlaceholder ? (
            <SectionElementContentTableRowPlaceholder
              key={TemplateHelperPubSub.getPlaceholderObjectKey(props.element.id, placeholderNodeIndex)}
              templateContext={props.templateContext}
              element={props.element}
              placeholder={nextPlaceholder}
              placeholderIndex={props.placeholderIndex + 1}
              startingNodeId={placeholderNode}
            />
          ) : (
            <SectionElementContentTableRow
              templateContext={props.templateContext}
              element={props.element}
              startingNodeId={placeholderNode}
            />
          )}
        </>
      ))}
    </>
  );
}
